module.exports = __webpack_public_path__ + "static/media/chevron_down_secondary.6797743a.svg";